import { Link } from 'react-router-dom';

const SEARCH_TYPES = [
  {
    icon: 'ri-heart-line',
    title: 'Pet Friendly Cabins in Highlands, NC',
    body: 'Several cabins in Highlands, NC welcome dogs and other pets, making it one of the most pet-friendly mountain destinations in the Southeast. Glen Falls Luxury Cabin is one of the top-rated pet-friendly options in the area — offering a wooded setting, easy access to nearby trails, and a private outdoor space perfect for guests traveling with dogs.',
    link: '/pet-friendly-cabins-highlands-nc',
    linkLabel: 'See Pet Friendly Cabins',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Luxury Cabins in Highlands, NC',
    body: 'Highlands has developed one of the most refined luxury cabin markets in the Blue Ridge Mountains. Guests can expect premium finishes, stone fireplaces, gourmet kitchens, covered decks with forest views, and a level of privacy that sets these properties apart from standard vacation rentals.',
    link: '/best-luxury-cabins',
    linkLabel: 'See Luxury Cabins',
  },
  {
    icon: 'ri-fire-line',
    title: 'Cabins with Fireplace in Highlands, NC',
    body: 'A fireplace is one of the most sought-after features in a Highlands cabin — and many of the best properties offer both indoor and outdoor options. Glen Falls Luxury Cabin, for example, features both an indoor fireplace and an outdoor wood-burning fireplace, making it a standout choice for guests who want the full mountain cabin experience.',
    link: '/best-luxury-cabins',
    linkLabel: 'Browse Fireplace Cabins',
  },
];

export default function CabinSearchTypesSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ What Are You Looking For?</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Find the Perfect Cabin<br /><em className="italic">in Highlands, NC</em>
          </h2>
        </div>

        <div className="space-y-5">
          {SEARCH_TYPES.map((item) => (
            <div key={item.title} className="bg-white rounded-2xl p-8 md:p-10 flex flex-col md:flex-row gap-7 items-start">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0">
                <i className={`${item.icon} text-[#2D4A3E] text-xl`} />
              </div>
              <div className="flex-1">
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-3">{item.title}</h3>
                <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-5">{item.body}</p>
                <Link
                  to={item.link}
                  className="inline-flex items-center gap-2 text-[#2D4A3E] text-xs font-jost tracking-[0.15em] uppercase hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
                >
                  {item.linkLabel}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
